import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/settings/analysis-groups/")({
  beforeLoad: () => {
    throw redirect({
      to: "/settings/analysis-groups/players",
    })
  },
})
